import { createSlice } from "@reduxjs/toolkit";
import { ReturnRequestsDetails } from "./services/returnRequestService";


interface ReturnRequestState {
    returnRequests: ReturnRequestsDetails[];
    loading: boolean;
    error: any;
    rowsPerPage: number;
}

const initialState: ReturnRequestState = {
    returnRequests: [],
    loading: false,
    error: null,
    rowsPerPage: 10,
};

export const returnRequestsSlice = createSlice({
    name: "returnRequests",
    initialState,
    reducers: {
        setRowsPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        clearRowsPerPage(state) {
            state.rowsPerPage = 10;
        }
    },
});

export const { setRowsPerPage, clearRowsPerPage } = returnRequestsSlice.actions;

export default returnRequestsSlice.reducer;
